import { render, staticRenderFns } from "./Municipalities.vue?vue&type=template&id=098ba4da&scoped=true&"
import script from "./Municipalities.vue?vue&type=script&lang=js&"
export * from "./Municipalities.vue?vue&type=script&lang=js&"
import style0 from "./Municipalities.vue?vue&type=style&index=0&id=098ba4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ba4da",
  null
  
)

export default component.exports